import { AngularMultiselectOption } from '@app/shared/common/common-classes/AngularMultiselectOption';
import { DropdownSettings } from 'angular2-multiselect-dropdown/lib/multiselect.interface';
import { ActivityCategory } from './service-proxies/service-proxies';
import { MonthStatus } from '@shared/AppEnums';

export class AppConsts {
    static readonly userManagement = {
        defaultAdminUserName: 'admin',
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'App',
    };

    static readonly grid = {
        defaultPageSize: 10,
    };

    static readonly partnerUsers = {
        maxResultCount: 500,
    };

    static readonly analyticsChart = {
        orderManageRoute: '/orders/manage',
        quoteMangeRoute: '/quotes/manage',
        customersEditRoute: '/customer/edit',
        locationEditRoute: '/location/edit',
        manageCustomerRoute: '/customer/manage',
        editQuotesRoute: '/quotes/edit',
        partnerEditRoute: '/partner/edit'
    };

    static readonly rolesName = {
        investOwner: 'Invest Owner',
        strategicPartnerManager: 'Strategic Partner Manager',
        executiveDirector: 'Executive/Director',
        admin: 'Admin',
        accountManager: 'Account Manager',
        salesSupport: 'Sales Support',
        orderSupport: 'Order Support',
        commissionSupervisor: 'Commission Supervisor',
        commissionManager: 'Commission Manager',
        salesSupportSupervisor: 'Sales Support Supervisor',
        orderSupportSupervisor: 'Order Support Supervisor',
    };
    static readonly notAvailable: string = 'N/A';

    static readonly environmentMappingFeatureFlag = {
        local: 'http://localhost:18000/api/v1/evaluation/public/',
        production: '/api/appconfigr/api/v1/evaluation/public/',
    };

    static readonly searchTypeListBilling = ['InvestOwner', 'Partner', 'Provider', 'SPM'];
    /**
     * Indicates the minimum amount of items that are not in the local memory, to trigger a remote request
     */
    static readonly BloodhoundSufficient: number = 1;

    static readonly BackgroundJobStatusDropdownItems: AngularMultiselectOption[] = [
        {
            id: 0,
            itemName: 'Unknown',
        },
        {
            id: 1,
            itemName: 'Queued',
        },
        {
            id: 2,
            itemName: 'Started',
        },
        {
            id: 3,
            itemName: 'Completed',
        },
        {
            id: 4,
            itemName: 'Failed',
        },
        {
            id: 5,
            itemName: 'Cancelled',
        },
    ];

    static readonly ContactViewType = {
        None: 0,
        AppSmart: 1,
        Provider: 2,
        Partner: 3,
    };

    static readonly defaultTenantId: number = 1;
    /**
     * Default Ticket Source Id for the Application
     */
    static readonly defaultTicketSourceId: number = 2;

    static readonly QueuedJobTypes = {
        ReprocessCommissionJob: 'ReProcessCommissionJob',
    }

    static readonly defaultCustomerDropdownText: string  = 'Select Customer';
    static readonly defaultEmptyCustomerDropdownText: string = 'Please select an advisor in order to search';
}

export enum Roles {
    Admin = 2,
    User = 3,
    Partner = 5,
    Provider = 6,
    PartnerManager = 7,
    StrategicPartnerManager = 8,
    PartnerAdmin = 9,
    ProviderAdmin = 10,
    SalesAgent = 11,
    SalesEngineer = 12,
    Support = 13,
    CommissionManager = 14,
    PartnerCommissions = 15,
    Employee = 16,
    ExecutiveDirector = 17,
    Contracts = 18,
    PartnerPrincipal = 19,
    Marketing = 20,
    Accounting = 21,
    SalesSupport = 22,
    SalesSupportSupervisor = 23,
    OrderSUpport = 24,
    OrderSupportSupervisor = 25,
    OpportunityAdmin = 26,
    Opportunity = 27,
    HeroModerator = 28,
    HeroContributor = 29,
    HeroAdmin = 30,
    InvestOwner = 32,
    CommissionSupervisor = 34,
}

export const statesArray: Array<Array<string>> = [
    ['US-AL', 'Alabama'],
    ['US-AK', 'Alaska'],
    ['US-AZ', 'Arizona'],
    ['US-AR', 'Arkansas'],
    ['US-CA', 'California'],
    ['US-CO', 'Colorado'],
    ['US-CT', 'Connecticut'],
    ['US-DE', 'Delaware'],
    ['US-FL', 'Florida'],
    ['US-GA', 'Georgia'],
    ['US-HI', 'Hawaii'],
    ['US-ID', 'Idaho'],
    ['US-IL', 'Illinois'],
    ['US-IN', 'Indiana'],
    ['US-IA', 'Iowa'],
    ['US-KS', 'Kansas'],
    ['US-KY', 'Kentucky'],
    ['US-LA', 'Louisiana'],
    ['US-ME', 'Maine'],
    ['US-MD', 'Maryland'],
    ['US-MA', 'Massachusetts'],
    ['US-MI', 'Michigan'],
    ['US-MN', 'Minnesota'],
    ['US-MS', 'Mississippi'],
    ['US-MO', 'Missouri'],
    ['US-MT', 'Montana'],
    ['US-NE', 'Nebraska'],
    ['US-NV', 'Nevada'],
    ['US-NH', 'New Hampshire'],
    ['US-NJ', 'New Jersey'],
    ['US-NM', 'New Mexico'],
    ['US-NY', 'New York'],
    ['US-NC', 'North Carolina'],
    ['US-ND', 'North Dakota'],
    ['US-OH', 'Ohio'],
    ['US-OK', 'Oklahoma'],
    ['US-OR', 'Oregon'],
    ['US-PA', 'Pennsylvania'],
    ['US-RI', 'Rhode Island'],
    ['US-SC', 'South Carolina'],
    ['US-SD', 'South Dakota'],
    ['US-TN', 'Tennessee'],
    ['US-TX', 'Texas'],
    ['US-UT', 'Utah'],
    ['US-VT', 'Vermont'],
    ['US-VA', 'Virginia'],
    ['US-WA', 'Washington'],
    ['US-WV', 'West Virginia'],
    ['US-WI', 'Wisconsin'],
    ['US-WY', 'Wyoming'],
];

export const states: Object = {
    'US-AL': 'Alabama',
    'US-AK': 'Alaska',
    'US-AZ': 'Arizona',
    'US-AR': 'Arkansas',
    'US-CA': 'California',
    'US-CO': 'Colorado',
    'US-CT': 'Connecticut',
    'US-DE': 'Delaware',
    'US-FL': 'Florida',
    'US-GA': 'Georgia',
    'US-HI': 'Hawaii',
    'US-ID': 'Idaho',
    'US-IL': 'Illinois',
    'US-IN': 'Indiana',
    'US-IA': 'Iowa',
    'US-KS': 'Kansas',
    'US-KY': 'Kentucky',
    'US-LA': 'Louisiana',
    'US-ME': 'Maine',
    'US-MD': 'Maryland',
    'US-MA': 'Massachusetts',
    'US-MI': 'Michigan',
    'US-MN': 'Minnesota',
    'US-MS': 'Mississippi',
    'US-MO': 'Missouri',
    'US-MT': 'Montana',
    'US-NE': 'Nebraska',
    'US-NV': 'Nevada',
    'US-NH': 'New Hampshire',
    'US-NJ': 'New Jersey',
    'US-NM': 'New Mexico',
    'US-NY': 'New York',
    'US-NC': 'North Carolina',
    'US-ND': 'North Dakota',
    'US-OH': 'Ohio',
    'US-OK': 'Oklahoma',
    'US-OR': 'Oregon',
    'US-PA': 'Pennsylvania',
    'US-RI': 'Rhode Island',
    'US-SC': 'South Carolina',
    'US-SD': 'South Dakota',
    'US-TN': 'Tennessee',
    'US-TX': 'Texas',
    'US-UT': 'Utah',
    'US-VT': 'Vermont',
    'US-VA': 'Virginia',
    'US-WA': 'Washington',
    'US-WV': 'West Virginia',
    'US-WI': 'Wisconsin',
    'US-WY': 'Wyoming',
};

/**
 * Default Dropdown Settings for the Angular2 Select component
 */
export const dropdownSettings: { single: DropdownSettings; multiple: DropdownSettings } = {
    /** Single selection settings */
    single: {
        enableCheckAll: false,
        enableFilterSelectAll: false,
        singleSelection: true,
        showCheckbox: false,
        enableSearchFilter: true,
        lazyLoading: true,
        position: 'bottom',
        autoPosition: false,
        tagToBody: false,
    },
    /** Multiple selections settings */
    multiple: {
        enableCheckAll: true,
        enableFilterSelectAll: true,
        singleSelection: false,
        showCheckbox: true,
        enableSearchFilter: true,
        lazyLoading: true,
        position: 'bottom',
        autoPosition: false,
        tagToBody: false,
    },
};

export const appSmartBackgroundColorArray: Array<String> = ['#006080', '#009ABF', '#286090', '#707070', '#F1E540', '#221c35'];

export const appsmartBlue: string = '#006080';

export const JOB_NOTIFICATION_NAMES = {
    Started: 'App.JobExecutionStarted',
    Finished: 'App.JobExecutionFinished',
    Failed: 'App.JobExecutionFailed',
};

export enum ActivityCategories {
    Note = ActivityCategory._1,
    Email = ActivityCategory._2,
    FollowUp = ActivityCategory._3,
    Activity = ActivityCategory._4,
}

export const screenNames = {
    Begin: 'Begin',
    Locations: 'Locations',
    Products: 'Products',
    ContractTerms: 'Contract Terms',
    Providers: 'Providers',
    MatchProduct: 'Match Product',
    Review: 'Review',
};

export const LOCKED_MONTH_STATUSES: number[] = [
    MonthStatus.Locked,
    MonthStatus.AdjustmentsGenerated,
    MonthStatus.PayoutSent,
    MonthStatus.Closed,
];

//Commission Tracking Type RESIDUAL is the default, RESIDUAL tracking type Id is 1
export const DefaultCommissionTypeId: number = 1;
